import React, { Component } from "react";
import { connect } from "react-redux";
import Menu from "components/menu";
import PROVIDER_CONFIG from "./provider_config";

class TrainingDiary extends Component {
  render() {
    return <Menu {...PROVIDER_CONFIG} {...this.props} />;
  }
}

const mapStateToProps = (state) => {
  return {
    messages: {
      ...state.intl.messages.containers.features.trainingDiary,
      trainingTypes:
        state.intl.messages.components.forms.selectOptions.trainingTypes,
      components: {
        chart: state.intl.messages.components.chart,
      },
    },
    trainingDiary: state.reducers.trainingDiary,
    providerContact: { _id: state.reducers.pets.selectedPet._user },
  };
};

export default connect(mapStateToProps)(TrainingDiary);
